<template>
    <div id="financialInterest">
        <el-form ref="searchForm" :model="searchForm" style="width:100%" :inline="true" :label-position="labelPosition">
            <el-form-item style="width:160px;margin-bottom:15px">
                <el-input clearable v-model.trim="searchForm.orderNumber" placeholder="订单编号"></el-input>
            </el-form-item>
            <el-form-item style="width:150px;margin-bottom:15px">
                <el-select filterable clearable v-model="searchForm.engineerId" placeholder="收款人">
                    <el-option v-for="(item,index) in pickingUserAllList"
                        :label="item.name"
                        :value="item.id"
                        :key="index">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item style="width:160px;margin-bottom:15px">
                <el-select filterable v-model="searchForm.status" placeholder="请选择订单状态" clearable>
                    <el-option v-for="(item,index) in pickingStatusList"
                        :label="item.paraName"
                        :value="item.paraCode"
                        :key="index">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item style="width:160px;margin-bottom:15px">
                <el-select filterable v-model="searchForm.payTypeId" placeholder="请选择支付方式" clearable>
                    <el-option v-for="(item,index) in payWayList"
                        :label="item.paraName"
                        :value="item.paraValue"
                        :key="index">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item style="width:160px;margin-bottom:15px">
              <el-select filterable v-model="searchForm.orderIdentifier" placeholder="请选择来源" clearable>
                <el-option v-for="(item,index) in orderIdentifierList"
                           :label="item.paraName"
                           :value="item.paraValue"
                           :key="index">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item style="width:350px;margin-bottom:15px">
                <el-date-picker
                    v-model="valueTime3"
                    type="daterange"
                    range-separator="-"
                    :default-time="['00:00:00', '11:59:59']"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item style="margin-bottom: 15px;">
                <el-button type="primary" size="medium" @click="onSubmit('searchForm')">查询</el-button>
                <el-button type="text" @click="clearFrom()" style="width: 60px;color: #169BD5;">重置</el-button>
            </el-form-item>
            <el-form-item class="fr">
                <el-col style="text-align:right">
                    <el-button type="success" size="medium" @click="downLoad.exportExcel('tableId')">导出</el-button>
                    <i class="el-icon-refresh" style="font-size: 25px;cursor: pointer;margin-left: 30px;" @click="refresh()"></i>
                </el-col>
            </el-form-item>
        </el-form>
        <el-card class="box-card" style="width: 100%;">
            <el-table
                :data="returnData"
                border
                id="tableId"
                @row-click="toDetail"
                :header-cell-style="{'text-align':'center'}"
                style="width: 100%">
                <el-table-column
                    align="center"
                    width="200"
                    label="订单号">
                    <template slot-scope="scope">
                        <span>{{scope.row.orderNumber}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                align="center"
                width="200"
                label="型号"
                prop="modelName">
                </el-table-column>
                <el-table-column  align="center"
                                  width="200"
                                  label="故障">
                  <template slot-scope="scope">
                    <div v-for="(item,index) in scope.row.faultSubclasses" :key="index">
                      {{item}}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="engineerName"
                    width="200"
                    label="收款人">
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="payTime"
                    width="200"
                    label="收款时间">
                    <template slot-scope="scope">
                        {{ scope.row.payTime | date }}
                    </template>
                </el-table-column>
                <el-table-column
                    align="center"
                    label="状态">
                    <template slot-scope="scope">
                        <span v-if="scope.row.status == '14'">已完成</span>
                        <span v-if="scope.row.status == '15'">退款中</span>
                        <span v-if="scope.row.status == '16'">退款完成</span>
                    </template>
                </el-table-column>
                <el-table-column align="center"
                prop="orderIdentifierName"
                label="来源">
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="payTypeName"
                    label="支付方式">
                </el-table-column>
                <el-table-column
                    prop="actualPrice"
                    align="center"
                    label="实收款(元)">
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="earnestPrice"
                    label="定金(元)">
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="inboundPrice"
                    label="成本(元)">
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="residualPrice"
                    label="残值估计(元)">
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="profitPrice"
                    label="利润(元)">
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="engineerTake"
                    label="工程师提成(元)">
                </el-table-column>
            </el-table>
        </el-card>
        <!--分页-->
        <el-col :span="24" class="toolbar">
            <div class="pagination">
                <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pages.page"
                    :page-sizes="[10, 20, 50, 100,500,1000,1500]"
                    :page-size="pages.pageSize"
                    layout="total, sizes, prev, pager, next,jumper"
                    :total="pages.total">
                </el-pagination>
            </div>
        </el-col>
    </div>
</template>

<script>
    let moment = require("moment");
    import { applyRefund,checkRefund,getOrderList,profitReport} from "../../api/order";
    import { engineerList,selectParameterInfoBusiness } from "../../api/api";
    import {queryUser} from '@/api/api';
    import store from '../../store/store';
    import {genUpToken} from "../basicSetting/com/qiniuToken.js";
    import {getPermission} from '../../api/authRequest'
    export default {
        name: 'financialInterest',
        data () {
            return {
                valueTime3:[],
                pickingStatusList:[
                    {
                        paraName:'已完成',
                        paraCode:'14'
                    },
                    {
                        paraName:'退款中',
                        paraCode:'15'
                    },
                    {
                        paraName:'退款完成',
                        paraCode:'16'
                    }
                ],
                pickingUserAllList:[],
                //分页变量
                pages:{
                    total: 0,
                    page: 1,
                    pageSize: 10,
                },
                labelPosition:'left',
                searchForm:{
                    status:'',         //状态
                    orderNumber:'',    //订单号
                    startPayTime:'',   //开始时间
                    endPayTime:'',     //结束时间
                    engineerId:'',     //收款人
                    payTypeId:'',
                   orderIdentifier:"",
                },
                returnData: [],
                payWayList: [],
                orderIdentifierList:[],
                basicsAuth:{
                    check_refund:false
                }
            }
        },
        mounted () {
            this.basicsAuth.check_refund= getPermission('/api/workOrder/refund/check_refund');
        },
        created(){
            this.getCurDate();
            this.getOrderPayList();
            this.getOrderIdentifier();
            this.getProfitReport();
            this.queryUserAllList();
        },
        methods: {
            //获取支付方式列表
            getOrderPayList(){
                selectParameterInfoBusiness({paraType:'pay_way',startRow:1,pageSize:10000}).then(res =>{
                    if(res.data.status==100){
                        this.payWayList = res.data.results.list;
                    }
                }).catch((error) => {
                    this.$Message.error(error.message);
                });
            },
          getOrderIdentifier(){
              selectParameterInfoBusiness({
                paraType: "order_identifier",
                startRow:1,
                pageSize: 10000,
              }).then(response=>{
                if(response.data.status==100){
                 this.orderIdentifierList = response.data.results.list;
                }
              }).catch((error) => {
                this.$Message.error(error.message);
              });
          },
            //查看详情
            toDetail(row,columns,event){
                this.$router.push({
                    path:"/orderDetail",
                    query:{
                        orderNo:row.orderNumber
                    }
                })
            },
            //获取昨天日期
            getCurDate(){
                let myDate = new Date();
                myDate.setDate(myDate.getDate() - 1);//设置日期
                let year = myDate.getFullYear();
                let month = (myDate.getMonth()+1) < 10 ? ("0" + (myDate.getMonth()+1)) : (myDate.getMonth() + 1);
                let day = myDate.getDate() < 10 ? ("0" + myDate.getDate()) : myDate.getDate();
                let dayNow = year + '-' + month + "-" + day;
                this.searchForm.startPayTime = dayNow;
                this.searchForm.endPayTime = dayNow;
                let start = dayNow + ' 00:00:00';
                let end = dayNow + " 23:59:59";
                this.valueTime3[0] = new Date(start);
                this.valueTime3[1] = new Date(end);
            },
            //查询所有系统账号
            queryUserAllList(){
                engineerList({startRow:1,pageSize:10000,state:1}).then(res =>{
                    if(res.data.status == '100'){
                        this.pickingUserAllList = res.data.results.list
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //重置
            clearFrom(){
                Object.keys(this.searchForm).forEach(key => this.searchForm[key]= '');
                this.valueTime3 = [];
                this.getProfitReport();
            },
            //获取财务利润列表
            getProfitReport(){
                this.searchForm.startRow = this.pages.page;
                this.searchForm.pageSize = this.pages.pageSize;
                profitReport(this.searchForm).then(res => {
                    if (res.data.status==100) {
                            this.returnData = res.data.results.list
                            this.pages.total = res.data.results.total
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            handleSizeChange(val) {
                this.pages.pageSize = val
                this.getProfitReport()
            },
            handleCurrentChange(Page) {
                this.pages.page = Page
                this.getProfitReport()
            },
            //刷新
            refresh() {
                this.clearFrom();
            },
            //
            onSubmit(formname) {
                this.$refs[formname].validate((valid) => {
                    if (valid) {
                        console.log(this.valueTime3)
                        if(this.valueTime3 == null){
                            this.searchForm.startPayTime = ''
                            this.searchForm.endPayTime = ''
                        }else if (this.valueTime3.length == 0) {
                            this.searchForm.startPayTime = ''
                            this.searchForm.endPayTime = ''
                        }else{
                            this.searchForm.startPayTime = this.moment(this.valueTime3[0]).format("YYYY-MM-DD");
                            this.searchForm.endPayTime = this.moment(this.valueTime3[1]).format("YYYY-MM-DD");
                        }
                        this.getProfitReport()
                    } else {
                        console.log('验证未通过');
                        return false;
                    }
                });
            }
        },
        computed: {},
        watch: {}
    }
</script>

<style type="text/css" lang="scss" scoped>
    .hide-upload{
        .el-upload {
            display: none;
        }
    }
    #financialInterest{
        font-size: 14px;
        .headerT{
            margin:0 0 15px 0;
        }
        tr.el-table__row{
            cursor: pointer;
        }
        input.el-input__inner{
            padding-right:25px;
        }
        .active-code{
            color:#409EFF
        }
        .avatar {
            width: 178px;
            height: 178px;
            display: inline-block;
        }
        .yuan{
            position:relative;
            &:after{
                position:absolute;
                right:0;
                content:'元';
                font-size:14px;
                color:#666;
                line-height:40px;
                width:30px;
                height:40px;
                top:0;
                display:block
            }
        }
    }

</style>



// WEBPACK FOOTER //
// financialInterest.vue?bd9829fe